/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
 
 import { Modal } from "react-bootstrap";
import BaseCom from "../BaseCom";
import FormInput from "../FormInput";
import { qreq } from "../../shared/qrequest";
import Icon from "../Icon";
import { withParamsAndNavigate } from "../WithParamsAndNavigate";

class RequestFormCreateModal extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {
            info: {},
            requestFormTypes: [],
            showSendModal: false
        };
        this.submit = this.submit.bind(this);
    }

    componentDidMount() {
        qreq.get('/api/form/type/list', j => {
            if(j.list)
                this.setState({ requestFormTypes: j.list });
        }, this.unkownErrorCallback);
    }

    componentDidUpdate(prevProps) {
        if(this.props.show !== prevProps.show) {
            this.setState({ info: {...this.state.info, emails: this.props.emails}});
        }
    }

    submit(e) {
        if(e) e.preventDefault();
        this.setState({ submitting: true });
        qreq.post('/api/form/create', {...this.state.info, orderID: this.props.orderID }, j => {
            if(j.errorCode === 0) {
                this.props.onHide();
                this.props.navigate('/form/request/' + j.item.uniqueIdent + '/inline');
            }
            else
                this.alert(j.errorMessage);
            this.setState({ submitting: false });
        }, () => {
            this.setState({ submitting: false });
            this.unkownErrorCallback();
        });
    }

    render() {
        return <Modal show={this.props.show} onHide={this.props.onHide}>
            <Modal.Header closeButton>
                Request Form
            </Modal.Header>
            <form onSubmit={this.submit}>
            <Modal.Body>
                <FormInput model={this.state.info} name="requestFormTypeID" label="Form Type" type="select" required options={this.state.requestFormTypes} />
            </Modal.Body>
            <Modal.Footer>
                <button type="submit" className="btn btn-success" disabled={this.state.submitting}><Icon icon="faArrowRight" /> Create</button>
                <button type="button" className="btn btn-secondary" onClick={this.props.onHide}><Icon icon="faCancel" /> Cancel</button>
            </Modal.Footer>
            </form>
        </Modal>;
    }
}

export default withParamsAndNavigate(RequestFormCreateModal);